import { NamedRoutes } from "./NamedRoutes";
export class PatientDeleteMyAccountConfirmationViewModel {
    constructor(container) {
        this.routingUIManager = container.routingUIManager;
    }
    goHome() {
        this.routingUIManager.redirectTo(NamedRoutes.LOGIN_AS_PATIENT);
    }
    onTalkToUsClicked() {
        window.open("https://www.healthex.io/contact-us", "_blank");
        this.goHome();
    }
}
